import { render, staticRenderFns } from "./DashboardAchievements.vue?vue&type=template&id=4ff0651a&scoped=true&"
import script from "./DashboardAchievements.vue?vue&type=script&lang=js&"
export * from "./DashboardAchievements.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAchievements.vue?vue&type=style&index=0&id=4ff0651a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff0651a",
  null
  
)

export default component.exports